module.exports = __webpack_public_path__ + "static/main-aee5015ceb56668c07f8180140955285.png";